/* tslint:disable:object-literal-sort-keys */
export const DURATIONS = {
  last_month: { label: "Last 30 Days", value: "last_month" },
  last_2_month: { label: "Last 60 Days", value: "last_2_month" },
  last_3_month: { label: "Last 90 Days", value: "last_3_month" },
  all_time: { label: "All Time", value: "all" }
};
